module.exports = __webpack_public_path__ + "static/img/41.e4fc803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/41.jpg
// module id = QebP
// module chunks = 1